<template>
	<div>
		<div class="col-12 pl-0 pr-0">
			<div class="col-12 pl-0 pr-0 d-flex flex-wrap">
				<div class="col-12 col-lg-12 px-0">
					<div class="col-12 px-2 py-3 p-md-3 d-flex flex-wrap rounded-cus cus-box-shadow bg-white">
						<div class="col-12 col-md-12 pl-0 d-md-flex justify-content-between" v-if="detailReceipt.sdo_code">
							<div class="font-size-14 font-size-sm-12 font-weight-bold color-blue">{{ detailReceipt.sdo_code }}</div>
							<div class="font-weight-bold">{{ detailReceipt.sdo_status_on_delivery_datetime | tanggaljam }}</div>
						</div>
						<div class="col-12 col-md-11 pl-0" v-else>
							<vcl :width='300' :height='10'>
								<rect x="0" y="0" rx="2" ry="2" width="85" height="10" />
								<rect x="245" y="0" rx="2" ry="2" width="55" height="10" />
							</vcl>
						</div>
					</div>
					<div>
						<div class="col-12 px-2 py-3 p-md-3 mt-3 rounded-cus cus-box-shadow bg-white" v-if="Object.values(detailReceipt).length == 0">
							<vcl :width='300' :height='142'>
								<rect x="5" y="3" rx="2" ry="2" width="75" height="10" />
								<rect x="5" y="20" rx="2" ry="2" width="30" height="6" />
								<rect x="45" y="20" rx="2" ry="2" width="75" height="6" />
								<rect x="5" y="30" rx="2" ry="2" width="30" height="6" />
								<rect x="45" y="30" rx="2" ry="2" width="50" height="6" />
								<rect x="5" y="40" rx="2" ry="2" width="30" height="6" />
								<rect x="45" y="40" rx="2" ry="2" width="50" height="6" />
								<rect x="5" y="54" rx="2" ry="2" width="120" height="50" />
								<rect x="130" y="54" rx="2" ry="2" width="120" height="50" />
								<rect x="5" y="113" rx="2" ry="2" width="30" height="6" />
								<rect x="5" y="123" rx="2" ry="2" width="75" height="6" />
								<rect x="5" y="133" rx="2" ry="2" width="75" height="6" />
								<rect x="85" y="128" rx="2" ry="2" width="40" height="6" />
								<rect x="130" y="113" rx="2" ry="2" width="30" height="6" />
								<rect x="130" y="123" rx="2" ry="2" width="75" height="6" />
								<rect x="130" y="133" rx="2" ry="2" width="75" height="6" />
								<rect x="210" y="128" rx="2" ry="2" width="40" height="6" />
							</vcl>
						</div>
						<div class="col-12 px-2 py-3 p-md-3 mt-3 d-flex flex-wrap rounded-cus cus-box-shadow bg-white" v-else>
							<div class="col-12 pb-3 font-size-sm-12 font-size-14 text-uppercase font-weight-bold">{{ detailReceipt.warehouse_name }}</div>
							<div class="col-12 pb-4 font-size-sm-10 font-size-12">
								<div class="row">
									<div class="col-12 col-md-2 font-weight-bold">Alamat</div>
									<div class="col-12 col-md-10">{{ detailReceipt.warehouse_address }}</div>
									<div class="pt-2 col-12 col-md-2 font-weight-bold">Phone</div>
									<div class="pt-md-2 col-12 col-md-10">{{ detailReceipt.warehouse_mobilephone }}</div>
								</div>
							</div>
							<div class="col-12 pb-4 font-size-sm-10 font-size-12">
								<div class="row">
									<div class="col-12 col-md-8 col-lg-6 pr-lg-2">
										<div class="col-12 py-2 rounded-cus border-dashed border-width-1 h-100">
											<div class="row">
												<div class="col-3">Nomor</div>
												<div class="col-9">
													<span>:</span>
													<span class="pl-3">{{ detailReceipt.sdo_code }}</span>
												</div>
												<div class="pt-2 col-3">Tanggal</div>
												<div class="pt-2 col-9">
													<span>:</span>
													<span class="pl-3">{{ detailReceipt.sdo_status_on_delivery_datetime | tanggaljam }}</span>
												</div>
												<div class="pt-2 col-3" v-if="false">Bayar</div>
												<div class="pt-2 col-9" v-if="false">
													<span>:</span>
													<span class="pl-3">BRI Rp 21.750.000</span>
												</div>
												<div class="pt-2 col-3">MC ID</div>
												<div class="pt-2 col-9">
													<span>:</span>
													<span class="pl-3">{{ userData.stockist_code }}</span>
												</div>
											</div>
										</div>
									</div>
									<div class="col-12 col-md-8 col-lg-6 pt-3 pt-lg-0 pl-lg-2">
										<div class="col-12 py-2 rounded-cus border-dashed border-width-1 h-100">
											<div class="row">
												<div class="col-3">Penerima</div>
												<div class="col-9 d-flex">
													<div>:</div>
													<div class="pl-3">{{ detailReceipt.customer_name }}</div>
												</div>
												<div class="pt-2 col-3">Telepon</div>
												<div class="pt-2 col-9 d-flex">
													<div>:</div>
													<div class="pl-3">{{ detailReceipt.customer_mobilephone }}</div>
												</div>
												<div class="pt-2 col-3">Alamat</div>
												<div class="pt-2 col-9 d-flex">
													<div>:</div>
													<div class="pl-3">{{ detailReceipt.customer_address }}</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="col-12 pb-2 pb-lg-4 font-size-12">
								<div class="pt-2 table-responsive">
									<table class="table table-bordered mb-0 font-size-sm-9 font-size-10">
										<thead class="bg-pos">
											<tr>
												<td>No</td>
												<td>Jenis Barang</td>
												<td>Jumlah</td>
											</tr>
										</thead>
										<tbody>
											<tr v-for="(product, i) in detailReceipt.detail" :key="product.sdo_detail_id">
												<td>{{ i+1 }}</td>
												<td>{{ product.sdo_detail_product_name }}</td>
												<td>{{ product.sdo_detail_quantity_received }}</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex';

export default {
	computed: {
		...mapState('receipt', ['detailReceipt']),
		...mapState('auth', ['userData']),
	},
};
</script>